'use strict';

ClientDataRequesterClassFactory.$inject = [
	'$q',
	'mx.SolutionBuilderAgent.EntityService',
	'mx.sb.Agent.DataQuery.BaseRequester',
	'mx.sb.Agent.DataQuery.Enums',
	'mx.sb.Agent.DataQuery.FilterOperatorsFactory',
];
export default function ClientDataRequesterClassFactory($q, entityService, BaseRequester, DataQueryEnums, filterOperatorsFactory) {
	var ColumnSortingEnum = DataQueryEnums.ColumnSortingEnum;

	/**
	 * @ngdoc Class
	 * @name mx.sb.Agent.DataQuery.ClientDataRequester
	 *
	 * @description
	 * Class DataDefinition Requester
	 */

	function ClientDataRequester(dataQuery) {
		BaseRequester.call(this, dataQuery);

		this.options = {};

		this.supportedPreprocessors = {
			search: true,
			paging: true,
			sorting: true,
			columnSearch: true,
			advanceSearch: true,
		};
	}

	ClientDataRequester.prototype = angular.extend(Object.create(BaseRequester.prototype), {
		load: function (preprocessors) {
			return this._prepareData(preprocessors).then(function (dataItems) {
				var totalItems = dataItems.length;

				if (preprocessors && preprocessors.pagingPreprocessor) {
					preprocessors.pagingPreprocessor.totalItems = totalItems;
					var firstItemNumber = preprocessors.pagingPreprocessor.firstItemNumber - 1;
					var lastItemNumber = preprocessors.pagingPreprocessor.lastItemNumber;

					dataItems = dataItems.slice(firstItemNumber, lastItemNumber);
				}

				return {
					dataItems: dataItems,
					totalItems: totalItems,
				};
			});
		},

		getTotalItems: function (preprocessors) {
			return this._prepareData(preprocessors).then(function (dataItems) {
				return dataItems.length;
			});
		},

		getEntityTypes: async function () {
			return [
				{
					_displayName: '',
					_type: 'ClientStaticObject',
					_itemType: 'ClientStatic',
				},
			];
		},

		_getDisplayEntity: function (rawEntity, displayEntity, changedColumns) {
			return $q
				.all(
					changedColumns.map(function (column) {
						if (column.RawValuePropertyName) {
							displayEntity[column.Name + '_Value'] = rawEntity[column.RawValuePropertyName];

							if (column.IsEnum) {
								return column.getEnumValueTitle(rawEntity[column.RawValuePropertyName]).then(function (enumTitle) {
									displayEntity[column.Name] = enumTitle;
								});
							} else if (column.IsPickup) {
								return entityService.getFragmentDescriptorsInBatch(column.ReferenceTo, rawEntity[column.RawValuePropertyName]).then(function (objDetails) {
									displayEntity[column.Name] = objDetails && objDetails.DisplayString;
								});
							}

							switch (column.AttributeValueType) {
								case mx.shell.ObjectPropertyType.Boolean.name:
									displayEntity[column.Name] = Boolean(rawEntity[column.RawValuePropertyName]);
									break;
								default:
									displayEntity[column.Name] = rawEntity[column.RawValuePropertyName];
									break;
							}
						}
					})
				)
				.then(function () {
					return displayEntity;
				});
		},

		_getRows: function () {
			var dataQuery = this.dataQuery;

			if (this.rows && this.rows.length === this.options.items.length && this._items === this.options.items && this._dataQuery && this._dataQuery === dataQuery) {
				return $q.when(this._getFilteredRows(this.rows));
			}

			this._items = this.options.items;
			this._dataQuery = dataQuery;

			return $q
				.all(
					this.options.items.map(function (rawEntity) {
						return this.createRow(rawEntity);
					}, this)
				)
				.then(
					function (rows) {
						this.rows = rows;
						return this._getFilteredRows(rows);
					}.bind(this)
				);
		},

		_getFilteredRows: function (rows) {
			if (!this.options.hideItemFieldName) {
				return rows;
			}
			return rows.filter(function (row) {
				return row.getEntity()[this.options.hideItemFieldName] !== true;
			}, this);
		},

		_keywordFilter: function (item, keyword) {
			if (!keyword) {
				return true;
			}
			keyword = keyword.toLowerCase();

			return this.dataQuery.Columns.filter(function (column) {
				return column.IsKeyword;
			}).some(function (kColumn) {
				return this._isItemMatchCondition(item, {
					property: kColumn.Name,
					value: [keyword],
					operator: filterOperatorsFactory.operators.Contains.value,
				});
			}, this);
		},

		_queryGroupFilter: function (item, group) {
			var res = false;
			if (group.LogicalOperator === mx.SolutionBuilderAgent.SearchQueryLogicalOperator.AND) {
				res = group.Conditions.every(function (condition) {
					return this._isItemMatchCondition(item, condition);
				}, this);
				if (!res) {
					return res;
				}
				res = group.Groups.every(function (group) {
					return this._queryGroupFilter(item, group);
				}, this);
			} else if (group.LogicalOperator === mx.SolutionBuilderAgent.SearchQueryLogicalOperator.OR) {
				res = group.Conditions.some(function (condition) {
					return this._isItemMatchCondition(item, condition);
				}, this);
				if (res) {
					return res;
				}
				res = group.Groups.some(function (group) {
					return this._queryGroupFilter(item, group);
				}, this);
			} else {
				return true;
			}

			return res;
		},

		_normalizeValue: function (value, column) {
			if (value === null || typeof value === 'undefined') {
				return value;
			}

			if (column.IsEnum || column.IsPickup) {
				return value.toString().toLowerCase();
			}

			var type = column.AttributeValueType;

			switch (type) {
				case mx.shell.ObjectPropertyType.String.name:
				case mx.shell.ObjectPropertyType.Guid.name:
				case mx.shell.ObjectPropertyType.Text.name:
					return value.toString().toLowerCase();
				case mx.shell.ObjectPropertyType.Boolean.name:
					if (typeof value === 'string') {
						if (value === 'true') {
							return true;
						} else if (value === 'false') {
							return false;
						}
					}
					return Boolean(value);
				case mx.shell.ObjectPropertyType.Currency.name:
					return value; //TODO: parseInt ?
				case mx.shell.ObjectPropertyType.Date.name:
					var parsed = Date.parse(value);
					return isNaN(parsed) ? 0 : parsed;
				case mx.shell.ObjectPropertyType.Integer.name:
					return parseInt(value);
				case mx.shell.ObjectPropertyType.Float.name:
				case mx.shell.ObjectPropertyType.Long.name:
				case mx.shell.ObjectPropertyType.Decimal.name:
					return parseFloat(value);
				default:
					return typeof value === 'string' ? value.toLowerCase() : value;
			}
		},

		_isItemMatchCondition: function (item, condition) {
			var operator = filterOperatorsFactory.getOperatorByValue(condition.operator);
			var column = this.dataQuery.Columns.filter(function (column) {
				return column.Name === condition.property;
			})[0];
			if (!column) {
				return false;
			}

			if (column.IsEnum) {
				return operator.fn(item[column.Name + '_Value'], condition.value);
			} else {
				var itemValue = this._normalizeValue(item[condition.property], column);
				var conditionValues = condition.value.map(function (value) {
					return this._normalizeValue(value, column);
				}, this);

				return operator.fn(itemValue, conditionValues);
			}
		},

		_prepareData: function (preprocessors) {
			return this._getRows().then(
				function (rows) {
					var filters = [];

					if (!preprocessors) {
						return $q.when(rows);
					}

					if (preprocessors.searchPreprocessor) {
						filters.push({
							fn: this._keywordFilter,
							args: [preprocessors.searchPreprocessor.keyword],
						});
					}
					if (preprocessors.columnSearchPreprocessor || preprocessors.advanceSearchPreprocessor) {
						var group = {
							Conditions: [],
							Groups: [],
							LogicalOperator: mx.SolutionBuilderAgent.SearchQueryLogicalOperator.AND,
						};

						if (preprocessors.columnSearchPreprocessor) {
							group.Groups.push(preprocessors.columnSearchPreprocessor.conditions);
						}

						if (preprocessors.advanceSearchPreprocessor) {
							group.Groups.push(preprocessors.advanceSearchPreprocessor.conditions);
						}

						filters.push({
							fn: this._queryGroupFilter,
							args: [group],
						});
					}

					rows = rows.filter(function (item) {
						return filters.every(function (filter) {
							var args = (filter.args || []).slice();
							args.unshift(item);
							return filter.fn.apply(this, args);
						}, this);
					}, this);

					return this._sortItems(rows, preprocessors);
				}.bind(this)
			);
		},

		_sortItems: function (items, preprocessors) {
			if (!preprocessors.sortingPreprocessor) {
				return $q.when(items);
			}
			var sortedColumns = preprocessors.sortingPreprocessor.sortedColumns;

			// In source data enum titles can be not present by default, and only value is present
			// But sorting should be done by enum-title
			// So, if sorting is performed by enum-column then
			// it is necessary to load enumTitle for all items before sorting will be performed
			return this._checkEnums(items, sortedColumns).then(function () {
				items.sort(function (itemA, itemB) {
					var i = 0,
						compare = 0;

					while (i < sortedColumns.length && compare === 0) {
						var column = sortedColumns[i];
						var sortField = column.Name;

						if (column.SortingExpression) {
							sortField = sortField + '_Order';
						}

						var valueA = itemA[sortField],
							valueB = itemB[sortField];
						if ((typeof valueA === 'undefined' || valueA === null) && typeof valueB !== 'undefined' && valueB !== null) {
							compare = 1;
						} else if (typeof valueA !== 'undefined' && valueA !== null && (typeof valueB === 'undefined' || valueB === null)) {
							compare = -1;
						} else if ((typeof valueA === 'undefined' || valueA === null) && (typeof valueB === 'undefined' || valueB === null)) {
							compare = 0;
						} else {
							compare = valueA > valueB ? 1 : valueA === valueB ? 0 : -1;
						}

						if (column.Sorting === ColumnSortingEnum.Descending) {
							compare = compare * -1;
						}
						i++;
					}
					return compare;
				});

				return items;
			});
		},

		_checkEnums: function (items, sortedColumns) {
			return $q.all(
				sortedColumns.map(function (column) {
					if (!column.IsEnum) {
						return $q.when();
					}

					var valuePropertyName = column.Name + '_Value';

					var allEnumTitlesPresent = items.every(function (item) {
						return item[valuePropertyName] === null || typeof item[column.Name] !== 'undefined';
					});

					if (allEnumTitlesPresent) {
						return $q.when();
					}

					return column.getEnumValues();
				})
			);
		},
	});

	return ClientDataRequester;
}
